import { Helmet } from 'react-helmet'
import Header from '../../../Components/Header'
import WmsSettingForm from './WmsSettingForm'


const CreateSetting = () => {
    return (
        <div className="d-flex flex-column" style={{ height: '100vh' }}>
            <Helmet>
				<title>Setting - Create</title>
			</Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
                <WmsSettingForm />
            </div>
        </div>
    )
}

export default CreateSetting